import '../images/sprites/arrow_right.svg';
import '../images/sprites/arrow_left.svg';
import '../images/sprites/arrow_bottom.svg';
import '../images/sprites/logo_agency.svg';
import '../images/sprites/logo_agency_sm.svg';
import '../images/sprites/facebook.svg';
import '../images/sprites/linkedin.svg';
import '../images/sprites/skype.svg';
import '../images/sprites/infinity.svg';
import '../images/sprites/check.svg';
import '../images/sprites/close.svg';
import '../images/sprites/close_error.svg';
import '../images/sprites/eye_close.svg';
import '../images/sprites/eye_open.svg';
import '../images/sprites/next-logo.svg';
